import { NextPage } from 'next';
import Head from 'next/head';
import { useState } from 'react';
import ButtonWithFeedback from '../react-components/button-with-feedback';
import Layout from '../react-components/layout';
import fullWidthCard from '../styles/full-width-card.module.css';
import { useRequest } from '../utils/make-api-request';

const getRole = () => new URLSearchParams(window.location.search).get('role');

const VerifyEmail: NextPage = () => {
  const [email, setEmail] = useState('');
  const [resetPasswordRequest, resetPassword] = useRequest('email-verification-tokens', 'post');
  const done = resetPasswordRequest.data !== undefined;
  return (
    <Layout>
      <Head>
        <title>Verify your Email</title>
      </Head>
      {done ? (
        <>
          <h1>All Set!</h1>
          <p>Check your email for a link to verify it.</p>
        </>
      ) : (
        <form
          onSubmit={e => {
            e.preventDefault();
            resetPassword({ email, role: getRole() });
          }}
          className={fullWidthCard.fullWidthCard}
        >
          <h1 className='select-none'>Verify your Email</h1>
          <p>
            You should&rsquo;ve gotten an email verification link when you made an account, but in case that
            didn&rsquo;t come through you can resend that verification email here.
          </p>
          <div className='my-4'>
            <input value={email} onChange={e => setEmail(e.target.value)} required placeholder='Email' type='email' />
          </div>
          <ButtonWithFeedback request={resetPasswordRequest} type='submit' className='primary'>
            Send Email
          </ButtonWithFeedback>
        </form>
      )}
    </Layout>
  );
};

export default VerifyEmail;
